import { ApiClient } from './ApiClient.js'
import params from './params.js'

const api = new ApiClient(params)

export default api
